module.exports = __webpack_public_path__ + "img/mw.838eab18.png";